import React, { useState, useEffect } from 'react';
// import { apiRequest } from '../api/index';
import ProfileLeft from '../components/Profile/ProfileLeft';
import ProfileRight from '../components/Profile/ProfileRight';
import {getAuthenticatedUser} from "../api/auth.sso";


const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загрузка данных пользователя
  useEffect(() => {
    let isMounted = true;
    
    const loadUserData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // 1. Получаем данные пользователя
        const userData = await getAuthenticatedUser();
        console.log("userData: ", userData);
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (!isMounted) return;
        
        setUserData(userData);
        
      } catch (error) {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          console.error('Ошибка при загрузке данных профиля:', error);
          setError(error.message || 'Не удалось загрузить данные профиля');
        }
      } finally {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    loadUserData();
    
    // Очистка при размонтировании компонента
    return () => {
      isMounted = false;
    };
  }, []);



  // if (loading) {
  //   return (
  //       <main className="main-content">
  //         <div className="profile-container">
  //           <ProfileLeft
  //             loading={loading}
  //             userData={userData}
  //           />
  //           <ProfileRight
  //             loading={loading}
  //             userData={userData}
  //           />
  //         </div>
  //       </main>
  // )
  // }
  return (
    <main className="main-content">
        <div className="profile-container">
          <ProfileLeft
            loading={loading}
            userData={userData} 
          />
          
          <ProfileRight
            loading={loading}
            userData={userData} 
          />
        </div>
      </main>

  );
};

export default Profile;